<script setup lang="ts">
withDefaults(
  defineProps<{
    isVisible: boolean;
    isForced?: boolean;
  }>(),
  {
    isForced: false,
  },
);

const emit = defineEmits<{
  reload: [];
  dismiss: [];
}>();

const handleReload = () => {
  emit('reload');
};

const handleDismiss = () => {
  emit('dismiss');
};
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform translate-y-[-100%] opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform translate-y-[-100%] opacity-0"
  >
    <div
      v-if="isVisible"
      class="animate-border-pulse fixed top-4 right-4 left-4 z-10000 max-w-md rounded-lg border-2 border-(--base-accent-color) bg-(--base-element-color) p-4 text-(--base-text-color) shadow-lg sm:left-auto"
      style="
        box-shadow:
          0 0 20px rgba(115, 103, 240, 0.3),
          0 0 40px rgba(115, 103, 240, 0.1);
      "
    >
      <div class="flex items-center gap-3">
        <div class="flex-1">
          <p class="font-medium text-(--base-text-color)">
            {{ isForced ? 'Критическое обновление' : 'Доступна новая версия' }}
          </p>
          <p class="text-sm text-(--base-popup-secondary-color)">
            {{
              isForced
                ? 'Обновите страницу — работа на старой версии невозможна'
                : 'Обновите страницу для получения последних изменений'
            }}
          </p>
        </div>
        <button
          class="min-h-11 rounded bg-(--base-accent-color) px-4 py-2 text-sm font-medium whitespace-nowrap text-(--button-text-color) transition-[background-color,transform] duration-200 hover:bg-(--button-hover-color) active:scale-[0.96]"
          @click="handleReload"
        >
          Обновить
        </button>
        <button
          v-if="!isForced"
          class="min-h-11 min-w-11 rounded px-3 py-2 text-sm font-medium whitespace-nowrap text-(--base-popup-secondary-color) transition-[background-color,transform] duration-200 hover:bg-(--base-element-color) active:scale-[0.96]"
          aria-label="Отложить"
          @click="handleDismiss"
        >
          Отложить
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
@keyframes border-pulse {
  0%,
  100% {
    box-shadow:
      0 0 20px rgba(115, 103, 240, 0.3),
      0 0 40px rgba(115, 103, 240, 0.1);
  }
  50% {
    box-shadow:
      0 0 30px rgba(115, 103, 240, 0.5),
      0 0 60px rgba(115, 103, 240, 0.2);
  }
}

.animate-border-pulse {
  animation: border-pulse 2s ease-in-out infinite;
}
</style>
